<template>
  <EditableArea
    v-if="preFooter && Object.keys(preFooter).length"
    :content="preFooter"
  />
</template>

<script lang="ts" setup>
import { EditableArea } from '@magnolia/vue-editor';
import { usePageLoader } from '~/composables/custom/usePageLoader/usePageLoader';
import { useSSR } from '~/composables/useSSR/useSSR';

const { preFooter, getPreFooter } = usePageLoader('prefooter-inherited');
const { onSSR } = useSSR();

onSSR(async () => {
  if (preFooter.value) {
    return;
  }

  await getPreFooter();
});
</script>
